import React, { useContext } from 'react'
import styled from 'styled-components'
import AppContext from 'context'
import NumDisplay from 'components/num-display'
import mixins from 'utils/mixins'
import { determineColor, moneyFormat } from 'utils/helpers'

const NetWorth = styled.div`
  ${mixins.card}
`

const Flex = styled.div`
  display: flex; 
  justify-content: space-around;
`

export default () => {
  const { state } = useContext(AppContext)

  const grandTotals = Object.entries(state.worksheet_data).reduce((prev, curr) => {
    const [sectionId, items] = curr
    if (sectionId === 'Liabilities') {
      prev.self -= Object.values(items).reduce((p,c) => p += c.self, 0)
      prev.spouse -= Object.values(items).reduce((p,c) => p += c.spouse, 0)
      prev.joint -= Object.values(items).reduce((p,c) => p += c.joint, 0)
    } else {
      prev.self += Object.values(items).reduce((p,c) => p += c.self, 0)
      prev.spouse += Object.values(items).reduce((p,c) => p += c.spouse, 0)
      prev.joint += Object.values(items).reduce((p,c) => p += c.joint, 0)
    }
    return prev
  }, {self: 0, spouse: 0, joint: 0})

  return (
    <NetWorth>
      <h2 style={{textAlign: 'center'}}>Net Worth</h2>
      <hr/>
      <Flex>
        <NumDisplay
          className="grand"
          bigNum={moneyFormat.to(grandTotals.self)}
          heading="self"
          style={{textAlign: 'center'}}
        />
        <NumDisplay
          className="grand"
          bigNum={moneyFormat.to(grandTotals.spouse)}
          heading="spouse"
          style={{textAlign: 'center'}}
        />
        <NumDisplay
          className="grand"
          bigNum={moneyFormat.to(grandTotals.joint)}
          heading="joint"
          style={{textAlign: 'center'}}
        />
        <NumDisplay
          className="grand"
          bigNum={moneyFormat.to(grandTotals.self + grandTotals.spouse + grandTotals.joint)} 
          heading="net worth" 
          style={{textAlign: 'center', color: determineColor(grandTotals.self + grandTotals.spouse + grandTotals.joint)}} 
        />
      </Flex>
    </NetWorth>
  )
}